module.exports = __webpack_public_path__ + "static/media/foto_gwarancja_zwrotu.b32e46c0.jpg";